import MaterialTypography from "../../../../__snowpack__/pkg/@mui/material/Typography.js";
import React from "react";
import IconButton from "../icon-button/icon-button.component.js";
import {DrawerContainer, DrawerContent, DrawerTitle, DrawerWrapper} from "./drawer.styles.js";
function Drawer({
  anchor = "left",
  children,
  icon = "close",
  onClose,
  open,
  title,
  titleVariant = "h5"
}) {
  return /* @__PURE__ */ React.createElement(DrawerContainer, {
    anchor,
    open,
    onClose,
    ModalProps: {
      keepMounted: true,
      BackdropProps: {
        invisible: true
      }
    }
  }, /* @__PURE__ */ React.createElement(DrawerWrapper, null, /* @__PURE__ */ React.createElement(DrawerTitle, null, /* @__PURE__ */ React.createElement(MaterialTypography, {
    variant: titleVariant
  }, title), /* @__PURE__ */ React.createElement(IconButton, {
    onClick: onClose
  }, icon)), /* @__PURE__ */ React.createElement(DrawerContent, null, children)));
}
export default /* @__PURE__ */ React.memo(Drawer);
